import { Theme, withStyles, WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import ListItemText from '@material-ui/core/ListItemText';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import { createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import React from 'react';
import { IDataRootObject } from './types';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    filterWrapper: {
      display: 'flex',
      alignItems: 'center',
      textTransform: 'none'
    },
    subheadingWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: '1rem'
    },
    wrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    status: {
      fontSize: '14px',
      textTransform: 'none'
    },
    iconContainer: {
      border: `1px solid rgba(255,255,255,0.2)`
    },
    buttonContainer: {
      marginRight: 15,
      marginLeft: 15
    },
    buttonleftFix: {
      marginLeft: -2
    },
    smallText: {
      fontSize: 10
    },
    radio: {
      paddingLeft: 0
    }
  });

const StyledMenu = withStyles({
  paper: {
    // border: '1px solid #d3d4d5',
  }
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      // backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white
      }
    }
  }
}))(MenuItem);

const CustomOutlineButton = withStyles((theme) => ({
  root: {
    boxShadow: 'none',
    border: '2px solid',
    backgroundColor: 'transparent',
    borderColor: `${theme.palette.text.primary}`,
    borderRadius: 2,
    opacity: 0.4,
    // '&:hover': {
    //   opacity: 1
    // },
    '&.active': {
      opacity: 1
    }
  }
}))(Button);

interface ISubheadingBarOwnProps extends WithStyles<typeof styles> {
  row: IDataRootObject;
  switchTo: (arg0: { mode?: string }) => void;
}

const DetailHeading: React.FC<ISubheadingBarOwnProps> = ({
  classes,
  row,
  switchTo
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  return (
    <div className={classes.subheadingWrapper}>
      <div className={classes.wrapper}>
        <div className={classes.filterWrapper}>Switch Mode</div>
        <div className={classes.buttonContainer}>
          <CustomOutlineButton
            variant="outlined"
            className={row.switch_mode === 'AS_MODE_AUTO' ? 'active' : ''}
            onClick={() => {
              if (row.switch_mode === 'AS_MODE_AUTO') {
                return;
              }
              switchTo({
                mode: 'auto'
              });
            }}
          >
            AUTOMATIC
          </CustomOutlineButton>
          <CustomOutlineButton
            variant="outlined"
            className={`${classes.buttonleftFix} ${
              row.switch_mode === 'AS_MODE_FORCE' ? 'active' : ''
            }`}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            MANUAL <KeyboardArrowDownIcon />
          </CustomOutlineButton>
          <StyledMenu
            id="customized-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClick={() => setAnchorEl(null)}
          >
            <StyledMenuItem>
              <ListItemText primary={`Active : ${row.active_source.name}`} />
            </StyledMenuItem>
            <StyledMenuItem
              onClick={(e) => {
                e.preventDefault();
                switchTo({});
              }}
            >
              <Radio className={classes.radio} />
              {row.backup_source.name}
            </StyledMenuItem>
          </StyledMenu>
        </div>
        <Typography className={classes.status}>
          {row.updated_at} <span className={classes.smallText}>IST</span>
        </Typography>
      </div>
      {/* <div className={classes.iconContainer}>
        <IconButton aria-label="alarm">
          <NotificationsActiveIcon />
        </IconButton>
      </div> */}
    </div>
  );
};

export default withStyles(styles)(DetailHeading);
